// extracted by mini-css-extract-plugin
var _1 = "InvitationGoogleConnect-module__connectButton--iueKj";
var _2 = "InvitationGoogleConnect-module__connectMessage--lSh70";
export { _1 as "connectButton", _2 as "connectMessage" }
